import { FilterRule } from '../types/grid';

export interface GridPersistentSettings {
  filterRules?: FilterRule[];
  sortRules?: Array<{ id: string; desc: boolean }>;
  sortCol?: string;
  sortDir?: 'asc' | 'desc';
  pageSize?: number;
}

const STORAGE_PREFIX = 'ericius_grid_settings_';

export const getGridSettings = (key: string): GridPersistentSettings | null => {
  if (!key) return null;
  try {
    const raw = localStorage.getItem(`${STORAGE_PREFIX}${key}`);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};

export const saveGridSettings = (key: string, settings: Partial<GridPersistentSettings>): void => {
  if (!key) return;
  try {
    const existing = getGridSettings(key) || {};
    const updated: GridPersistentSettings = {
      ...existing,
      ...settings,
    };
    localStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(updated));
  } catch (e) {
    // ignore quota/private browsing issues
  }
};

export const clearGridSettings = (key: string): void => {
  if (!key) return;
  try {
    localStorage.removeItem(`${STORAGE_PREFIX}${key}`);
  } catch (e) {
    // ignore
  }
};
